import React from "react";
import Headers from "../components/Header";
import Footer from "../Screen/Footer";

const PrivacyPolicy = () => {
  return (
    <div>
      <Headers />
      <section className="container terms-page">
        <h2 className="mb-3">Privacy Policy</h2>
        <p>
          This Privacy Policy applies exclusively to{" "}
          <span style={{ fontWeight: "bold" }}>Blaccdot Canada </span>{" "}
          (“Blaccdot”, “we”, “our”, or “us”). We are committed to protecting
          your privacy and safeguarding the personal information you share with
          us while using our website, platform, and services.
        </p>
        <p>
          By accessing or using Blaccdot Canada, you consent to the collection,
          use, and disclosure of your information in accordance with this
          Privacy Policy.
        </p>

        <h4>1. Who We Are</h4>
        <p>
          Blaccdot Canada is a Canadian lead generation company providing live,
          verified, and high-quality leads for moving and home service
          businesses across <span style={{ fontWeight: "bold" }}>Canada.</span>
        </p>
        <h4>2. Information We Collect</h4>
        <span style={{ fontWeight: "bold" }}>
          <p>a. Personal Information</p>
        </span>
        <p>You may provide personal information when you:</p>
        <ul>
          <li>Fill out a form</li>

          <li>Register for services</li>
          <li>Contact us via email or phone</li>
        </ul>
        <p>This information may include:</p>
        <ul>
          <li>Name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Company name</li>
          <li>Service details or inquiries</li>
          <li>Location or service-related information</li>
          <p>
            You are not required to provide personal information when simply
            browsing our website.
          </p>
        </ul>
        <h4>3. How We Use Your Information</h4>
        <p>We collect and use your information to:</p>
        <ul>
          <li>Deliver and manage our services</li>
          <li>Respond to inquiries and support requests</li>
          <li>Improve user experience and platform functionality</li>
          <li>Send service-related communications</li>

          <li>
            Share updates, offers, or newsletters (you may opt out anytime)
          </li>
          <li>Comply with legal obligations</li>
        </ul>
        <p>We do not guarantee marketing performance or business results.</p>
        <h4>4. Data Sharing & Disclosure</h4>
        <p>Blaccdot Canada does not sell or trade personal information.</p>
        <p>We may share information with:</p>
        <ul>
          <li>
            Trusted service providers or contractors under confidentiality
            agreements
          </li>
          <li>Affiliates or partners assisting in service delivery</li>
          <li>Legal or regulatory authorities when required by law</li>
        </ul>
        <p>All third parties are obligated to protect your information.</p>
        <h4>5. Data Storage & International Transfers</h4>
        <p>
          Your personal data may be stored or processed in Canada and other
          countries where Blaccdot Canada or its partners operate.
        </p>
        <p>
          We take reasonable steps to ensure that transferred data remains
          protected under applicable Canadian privacy laws.{" "}
        </p>
        <h4>6. Data Retention</h4>
        <p>
          We retain personal information only as long as necessary to fulfill
          the purposes described in this Privacy Policy or as required by law.
          Once the purpose is fulfilled, data is securely deleted or
          anonymized.{" "}
        </p>
        <h4>7. Cookies & Tracking Technologies</h4>
        <p>Blaccdot Canada uses cookies to:</p>
        <p>We use cookies and similar technologies to:</p>
        <ul>
          <li>Improve website performance</li>
          <li>Analyze traffic and usage trends</li>
          <li>Enhance overall user experience</li>
        </ul>

        <p>Cookies may collect:</p>
        <ul>
          <li>IP address</li>
          <li>Browser type</li>
          <li>Device type</li>
          <li>Pages visited</li>
          <li>Date and time of access</li>
          <li>Referral source</li>
        </ul>
        <p>You can control or disable cookies through your browser settings.</p>
        <h4>8. Marketing Communications</h4>
        <p>
          We may send promotional emails, service updates, or newsletters
          related to our services.
        </p>
        <p>
          You may unsubscribe at any time using the link provided in our emails.
        </p>
        <p style={{ marginBottom: 3 }}>We do not send unsolicited spam.</p>
        <h4>9. Third-Party Links</h4>
        <p>
          Our website may contain links to third-party websites. These sites
          operate independently and have their own privacy policies. Blaccdot
          Canada is not responsible for the content or privacy practices of
          third-party websites.
        </p>
        <h4>10. Security Measures</h4>
        <p>We use commercially reasonable safeguards including:</p>
        <ul>
          <li>Secure servers</li>
          <li>Firewalls</li>
          <li>Access controls</li>
          <li>Confidentiality agreements with staff and partners</li>
        </ul>
        <p>
          However, no system is 100% secure. Users are encouraged to use strong
          passwords and updated security software.
        </p>
        <h4>11. Children’s Privacy</h4>
        <p>
          Blaccdot Canada does not knowingly collect personal information from
          individuals under{" "}
          <span style={{ fontWeight: "bold" }}>13 years of age.</span>
        </p>
        <p>
          If we become aware that such data has been collected, it will be
          deleted immediately.
        </p>
        <h4>12. Legal Disclosure & Abuse Prevention</h4>
        <p>We may disclose personal information:</p>
        <ul>
          <li>To comply with legal requirements</li>
          <li>To protect our rights, systems, or users</li>
          <li>To investigate fraud, abuse, or unlawful activity</li>
        </ul>
        <p>
          Any misuse of our platform may be reported to the appropriate
          authorities.
        </p>
        <h4>13. Changes to This Privacy Policy</h4>
        <p>
          Blaccdot Canada reserves the right to update this Privacy Policy at
          any time without prior notice. Continued use of our services indicates
          acceptance of the updated policy.
        </p>
        <h4>14. Contact Us</h4>
        <p>
          If you have any questions or concerns regarding this Privacy Policy,
          please contact us at:
        </p>
        <p>
          <span style={{ fontWeight: "bold" }}>📧 Email:</span>
          <a
            href="mailto:support@blaccdot.ca"
            className="text-blue-600 underline hover:text-blue-800"
          >
            support@blaccdot.ca
          </a>
        </p>
        <p>
          {" "}
          <span style={{ fontWeight: "bold" }}>🌐 Website:</span> blaccdot.ca
        </p>
      </section>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
